module.exports = __webpack_public_path__ + "img/logo.e2f3b72d.png";